import { SERVER_URL } from '../../constants';
import { fetchGetAuth, fetchRemoveAuth, fetchPostAuth } from '../../util/FetchUtil';

const controller = 'observacao-turma/';

const page = (codTdp, pageNumber) => {
  const url = SERVER_URL + controller + 
  'page?page=' + pageNumber + 
  '&codTdp=' + codTdp;
  return fetchGetAuth(url);
}

const findByCodigo = (codObservacaoTurma) => {
  const url = SERVER_URL + controller + '/' + codObservacaoTurma;
  return fetchGetAuth(url);
}

const remove = (codObservacaoTurma) => {
  const url = SERVER_URL + controller + 'delete/' + codObservacaoTurma;
  return fetchRemoveAuth(url);
}

const save = (observacaoTurma) => {
  const url = SERVER_URL + controller + 'save';
  return fetchPostAuth(url, observacaoTurma);
}

export {
  page,
  save,
  remove, 
  findByCodigo
}